import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { SlabRate } from 'utils/types';

const fetchSlabRates = async (offenceId: number): Promise<SlabRate[]> => {
  try {
    const response: AxiosResponse<SlabRate[]> = await axiosInstance.get(
      `offence/slabRates/${offenceId}`,
    );
    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    }
    throw new Error('An uknown error occured');
  }
};

const useGetSlabRates = (
  offenceId?: number,
  enabled = false,
): UseQueryResult<SlabRate[], Error> => {
  return useQuery<SlabRate[], Error>({
    queryKey: ['slabRates', offenceId],
    queryFn: () => fetchSlabRates(offenceId as number),
    enabled: Boolean(offenceId) && enabled,
    refetchOnWindowFocus: false,
  });
};

export default useGetSlabRates;
